<template>
  <div>
    <div v-if="globals.initialized && !globals.loading" class="job_offer_list_wrapper -max-width-limited">
      <template v-for="(job, index) in jobs.jobOffers" :key="index">
        <JobOffer :job="job"></JobOffer>
      </template>
      <div class="no-results" v-if="jobs.jobOffers.length === 0">
        <span>{{ $t('no-results') }}</span> <a :href="globals.jobDetailBaseUrl + '/' + jobLinkNoResult">{{ $t('no-results-link') }}</a>
      </div>
    </div>
    <div v-else class="job_offer_list_wrapper -max-width-limited">
      <div class="job__offer--loading" v-for="index in 12" :key="index">
        <div class="job__offer-item-title--loading job__offer--loading-item"></div>
        <div class="job__offer-item-category--loading job__offer--loading-item"></div>
        <div class="job__offer-item-location--loading job__offer--loading-item"></div>
      </div>
    </div>
  </div>
</template>

<script>
import JobOffer from '@/components/JobOffer.vue'
import { useJobOffersStore } from '@/stores/jobOffers'
import { useGlobalStore } from '@/stores'

export default {
  name: 'ResultList',
  components: {
    JobOffer
  },
  data() {
    return {
      jobLinkNoResult: window.tx_jobs.job_offer_list.job_link_noresult
    }
  },
  setup() {
    const jobs = useJobOffersStore();
    const globals = useGlobalStore();
    return {
      jobs,
      globals
    }
  },
}
</script>
